module.exports = __webpack_public_path__ + "images/category_lp/jewel/store_images/2_06499d1701881083263aee284907612c.png";